<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.fileNo">{{ baseInfo.fileNo }}</div>
                <div class="related-title">项目基础信息</div>
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="4" class="py-2">{{ baseInfo.title }}</th>
                    </tr>
                    <tr>
                        <td class="font-bold">项目名称 ：</td>
                        <td>{{ baseInfo.projectName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目编码 ：</td>
                        <td>{{ baseInfo.projectCode }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目业主名称 ：</td>
                        <td>{{ contact.purchaserName || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">业主单位咨询电话 ：</td>
                        <td>{{ contact.consultPhone || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">中选中介机构名称 ：</td>
                        <td>{{ baseInfo.bidAgentName || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">中介机构联系地址 ：</td>
                        <td>{{ notice.bidAgentOfficeAddress || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">服务内容 ：</td>
                        <td>{{ contact.serviceContent || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目规模 ：</td>
                        <td>{{ baseInfo.restrictions || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">服务金额 ：</td>
                        <td>
                            <span v-if="baseInfo.minServicePrice>0 || baseInfo.minServicePrice>0">{{ baseInfo.minServicePrice +' 至 ' + baseInfo.maxServicePrice || '-' }}</span>
                            <span v-else>-</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="font-bold">合同金额 ：</td>
                        <td>{{ baseInfo.contractPrice || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">合同时间 ：</td>
                        <td>{{ baseInfo.contractDate || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">服务终止时间 ：</td>
                        <td>{{ baseInfo.terminationDate || '-' }}</td>
                    </tr>

                </table>
                
                <ad :type="1"></ad>

                <div>
                    <div class="related-title">项目业务流程</div>
                    <div class="process"> 
                            <div class="process-title" 
                                @click="handleProcessClick(list)" 
                                v-for="list in processList" 
                                :class="list.value == processValue ? 'active' : ''" 
                                :style="list.id?'':'backgroundColor:#fff;color:rgb(204 204 204);cursor:not-allowed;'"
                                :key="list.value">
                                 {{ list.label }}
                            </div> 
                    </div>
                    <div>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="procurement && procurement.id && processValue == 1">
                            <tr>
                                <th>采购项目编码</th>
                                <td colspan="3">{{ procurement.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>采购项目名称</th>
                                <td colspan="3">{{ procurement.projectName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>项目业主名称</th>
                                <td colspan="3">{{ procurement.serviceSubjectName }}</td>
                            </tr> -->
                            <tr>
                                <th>中介服务事项</th>
                                <td colspan="3">{{ procurement.serviceSubjectName }}</td>
                            </tr>
                            <tr>
                                <th>业主单位咨询电话</th>
                                <td>{{ procurement.consultPhone }}</td>
                                <th>投资审批项目</th>
                                <td>{{ procurement.isInvestmentProject|| '-' }}</td>
                            </tr>
                            <tr>
                                <th>投资审批项目编码</th>
                                <td>{{ procurement.unifiedDealCode|| '-' }}</td>
                                <th>项目规模</th>
                                <td>{{ procurement.restrictions || '-'}}</td>
                            </tr>
                            <tr>
                                <th>中介机构要求</th>
                                <td>{{ procurement.agentRequirements }}</td>
                                <th>备案要求说明</th>
                                <td>{{ procurement.remark || '-'}}</td>
                            </tr>
                            <tr>
                                <th>其他要求说明</th>
                                <td>{{ procurement.otheRrequirements }}</td>
                                <th>服务时限说明</th>
                                <td>{{ procurement.serviceTimeLimit }}</td>
                            </tr>
                            <tr>
                                <th>服务内容</th>
                                <td>{{ procurement.serviceContent || '-' }}</td>
                                <th>服务时限说明</th>
                                <td>{{ procurement.serviceTimeLimit }}</td>
                            </tr><tr>
                                <th>服务金额</th>
                                <td>
                                    <span v-if="procurement.minServicePrice>0 || procurement.minServicePrice>0">{{ procurement.minServicePrice +' 至 ' + procurement.maxServicePrice || '-' }}</span>
                                    <span v-else>-</span>
                                </td>
                                <th>金额说明</th>
                                <td>{{ procurement.priceDescription }}</td>
                            </tr>
                            <tr>
                                <th>是否选取中介</th>
                                <td>{{ procurement.isMultipleSpecifiedAgent }}</td>
                                <th>有无回避情况</th>
                                <td>{{ procurement.isAvoided }}</td>
                            </tr>
                            <tr>
                                <th>截止报名时间</th>
                                <td colspan="3">{{ procurement.signupEndTime }}</td>
                            </tr>
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="notice && notice.id  && processValue == 2">
                            <tr>
                                <th>采购项目编码</th>
                                <td colspan="3">{{ notice.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>采购项目名称</th>
                                <td colspan="3">{{ notice.projectName }}</td>
                            </tr>
                            <tr>
                                <th>项目业主名称</th>
                                <td colspan="3">{{ notice.purchaserName }}</td>
                            </tr>
                            <tr>
                                <th>中介服务事项</th>
                                <td colspan="3">{{ notice.serviceSubjectName }}</td>
                            </tr>
                            <tr>
                                <th>投资审批项目编码</th>
                                <td>{{ notice.vcProcessProjectCode }}</td>
                            </tr>
                            <tr>
                                <th>服务金额</th>
                                <td>{{ notice.servicePrice }}</td>
                            </tr>
                            <tr>
                                <th>金额说明</th>
                                <td>{{ notice.priceDescription }}</td>
                            </tr>
                            <tr>
                                <th>选取中介机构方式</th>
                                <td>{{ notice.selectTypeName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>业务单位咨询电话</th>
                                <td>{{ notice.consultPhone || '-'}}</td>
                            </tr>
                            <tr>
                                <th>监督举报</th>
                                <td>{{ notice.complaintsHotLine }}</td>
                            </tr>
                            <tr>
                                <th>中选中介机构名称</th>
                                <td>{{ notice.bidAgentName }}</td>
                            </tr>
                            <tr>
                                <th>中介机构联系地址</th>
                                <td>{{ notice.bidAgentOfficeAddress }}</td>
                            </tr>
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="announcement  && processValue == 3">
                            <tr>
                                <th>采购项目编码</th>
                                <td colspan="3">{{ announcement.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>采购项目名称</th>
                                <td colspan="3">{{ announcement.projectName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>项目业主名称</th>
                                <td colspan="3">{{ announcement.serviceSubjectName }}</td>
                            </tr> -->
                            <tr>
                                <th>中介服务事项</th>
                                <td colspan="3">{{ announcement.serviceSubjectName }}</td>
                            </tr>
                            <tr>
                                <th>投资审批项目编码</th>
                                <td>{{ announcement.vcProcessProjectCode }}</td>
                                <th>服务金额</th>
                                <td>{{ announcement.servicePrice }}</td>
                            </tr>
                            <tr>
                                <th>金额说明</th>
                                <td>{{ announcement.priceDescription }}</td>
                                <th>选取中介机构方式</th>
                                <td>{{ announcement.selectTypeName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>指定理由</th>
                                <td>{{ announcement.directReason }}</td>
                                <th>中介机构联系地址</th>
                                <td>{{ announcement.bidAgentOfficeAddress || '-'}}</td>
                            </tr>
                            <tr>
                                <th>业务单位咨询电话</th>
                                <td>{{ announcement.consultPhone }}</td>
                                <th>监督举报</th>
                                <td>{{ announcement.complaintsHotLine }}</td>
                            </tr>
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="contact && contact.id  && processValue == 4">
                            <tr>
                                <th>采购项目编码</th>
                                <td colspan="3">{{ contact.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>采购项目名称</th>
                                <td colspan="3">{{ contact.projectName }}</td>
                            </tr>
                            <tr>
                                <th>项目业主名称</th>
                                <td colspan="3">{{ contact.purchaserName }}</td>
                            </tr>
                            <tr>
                                <th>中选中介机构名称</th>
                                <td>{{ contact.bidAgentName }}</td>
                            </tr>
                            <tr>
                                <th>合同名称</th>
                                <td>{{ contact.contractName }}</td>
                            </tr>
                            <tr>
                                <th>合同编号</th>
                                <td>{{ contact.contractCode }}</td>
                            </tr>
                            <tr>
                                <th>合同总金额</th>
                                <td>{{ contact.contractPrice }}</td>
                            </tr>
                            <tr>
                                <th>履约人员</th>
                                <td>{{ contact.performancePerson || '-'}}</td>
                            </tr>
                            <tr>
                                <th>服务期限说明</th>
                                <td>{{ contact.serviceTimeLimit || '-'}}</td>
                            </tr>
                            <tr>
                                <th>服务内容</th>
                                <td>{{ contact.serviceContent }}</td>
                            </tr>
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="termination && termination.id  && processValue == 5">
                            <tr>
                                <th>项目编码</th>
                                <td colspan="3">{{ termination.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>项目名称</th>
                                <td colspan="3">{{ termination.projectName }}</td>
                            </tr>
                            <tr>
                                <th>项目业主名称</th>
                                <td colspan="3">{{ termination.purchaserName }}</td>
                            </tr>
                            <tr>
                                <th>选取中介机构方式</th>
                                <td>{{ termination.selectTypeName }}</td>
                            </tr>
                            <tr>
                                <th>服务机构</th>
                                <td>{{ termination.serviceAgentName }}</td>
                            </tr>
                            <tr>
                                <th>服务终止时间</th>
                                <td>{{ termination.abortTime }}</td>
                            </tr>
                            <tr>
                                <th>服务终止原因</th>
                                <td>{{ termination.stopReason }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
            id: this.$route.query.id || null,
            baseInfo: {},
            processList: [
                { label: '采购公告', value: 1,type:'procurement',id:null },
                { label: '中选公示', value: 2,type:'notice',id:null },
                { label: '中选公告', value: 3,type:'announcement',id:null },
                { label: '合同公开', value: 4,type:'contact',id:null },
                { label: '服务终止', value: 5,type:'termination',id:null },
            ],
            processValue: 1,
            announcement: {},
            contact: {},
            notice: {},
            procurement: {},
            termination: {},
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        handleProcessClick(item) {
            if (!item.id) {
                // this.$message.warning('暂无数据');
                return;
            }
            this.processValue = item.value;
        },
        getData() {
            let ajaxUrl = this.$api.common.agencyService.Detail() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('数据详情', res);
                this.baseInfo = res.data.baseInfo || {};
                this.announcement = res.data.announcement || {};
                this.contact = res.data.contact || {};
                this.notice = res.data.notice || {};
                this.procurement = res.data.procurement || {};
                this.termination = res.data.termination || {};

                 // ★ 核心代码：将对应对象的 id 传入 processList
            this.processList.forEach(item => {
                // this[item.type] 相当于 this.procurement, this.notice 等
                const targetData = this[item.type]; 
                // 如果有数据且有 id 就赋值，否则给 null
                item.id = (targetData && targetData.id) ? targetData.id : null;
            });
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped> 

.detail-table.related-table{
    th,td{
        padding: 25px  10px;
    }
    th{
        background: #f1f8ff;
        width: 150px;
        min-width: 80px;
    }
    td{
        min-width: 220px;
        border: 1px solid #d6d6d6;
    }
}
.process {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #e6e6e6;
    border-radius: 5px;
    box-shadow: 0 2px 4px #ebf1f5;
    .process-title {
        width: calc(100%/5);
        font-size: 16px;
        color: #333;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-right: 1px solid #fff;
        font-weight: bold;
        &:hover,
        &.active {
            cursor: pointer;
            background-color: #2c5282;
            color: #ffffff;
        }
    }
} 

.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 15px 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>